module.exports = __webpack_public_path__ + "static/media/headerBackground.3e839765.jpg";